/* global fetch */

import { h, render, Component } from 'preact'
import moment from 'moment'
import 'moment-timezone'
import Hover from 'hover'
import storeDescriptor from '@root/store.js'

import VisualisationContainer from '@components/VisualisationContainer'

function apiResultToFeatures (apiResult) {
  return apiResult.data.map(station => {
    const coordinates = [station.coordinates.x, station.coordinates.y]

    station.todaysHourValues = station.values.map(value => {
      const hour = moment(value.t).tz('Europe/Berlin').hour()
      return { x: hour, y: value.y }
    })

    delete station.coordinates
    delete station.values

    return {
      'type': 'Feature',
      'properties': station,
      'geometry': {
        'type': 'Point',
        'coordinates': coordinates
      }
    }
  })
}

// ready, set, GO!
class Main extends Component {
  constructor (props) {
    super(props)
    this.store = Hover(storeDescriptor.actions, storeDescriptor.initialState)
    this.state = this.store()
  }

  handleResize = () => {
    this.store.updateScreenType({ screenWidth: window.innerWidth })
  }

  fetchMarkers = async ({ from, to }) => {
    from = encodeURIComponent(from)
    to = encodeURIComponent(to)

    const res = await fetch(`https://data.rbb-online.de/nox/data?from=${from}&to=${to}`)
    const json = await res.json()

    return apiResultToFeatures(json)
  }

  fetchData = async () => {
    const startOfDay = moment().tz('Europe/Berlin').startOf('day').utc()
    const endOfDay = moment().tz('Europe/Berlin').endOf('day').utc()

    let markers = await this.fetchMarkers({ from: startOfDay.format(), to: endOfDay.format() })

    // if we dont have values for today try yesterday
    // only do this for the first two hors of the day
    // if (markers.length === 0 && moment().tz('Europe/Berlin').hour() < 2) {
    // const startOfYesterday = startOfDay.subtract(1, 'days')
    // const endOfYesterday = endOfDay.subtract(1, 'days')
    // markers = await this.fetchMarkers({ from: startOfYesterday.format(), to: endOfYesterday.format() })
    // }

    this.store.setMarkers({ markers })
  }

  componentDidMount () {
    // register change listener
    this.unsubscribeFromStore = this.store(state => this.setState(state))
    window.addEventListener('resize', this.handleResize)
    this.handleResize()

    this.fetchData()
  }

  componentWillUnmount () {
    this.unsubscribeFromStore()
    window.removeEventListener('resize', this.handleResize)
  }

  // provide reference to store actions to all child components
  getChildContext () { return { actions: this.store } }

  render (props, state) {
    return <VisualisationContainer {...state} />
  }
}

// i think this fixes that the map is loaded to early and then rendered at the wrong size
window.addEventListener('load', () => {
  render(<Main />, document.body)
})
